import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_237: DocMigration = {
  maxSchemaVersion: "0.0.237",
  description: "Change name of concrete pier assembly to isolated.",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "FOUNDATION_CATALOG_SETTINGS") {
          for (const assemblyId in setting.foundationAssemblies) {
            const assembly = setting.foundationAssemblies[assemblyId];
            if (assembly.assemblySystem === "CONCRETE_PIER") {
              assembly.assemblySystem = "ISOLATED";
            }
          }
        }
      }
    }
    const { columns } = json;
    for (const columnId in columns) {
      const column = columns[columnId];
      for (const placementId in column.placements) {
        const placement = column.placements[placementId];
        if (placement.concretePierAssemblyId) {
          placement.isolatedAssemblyId = placement.concretePierAssemblyId;
          delete placement.concretePierAssemblyId;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_237;
